module.exports = __webpack_public_path__ + "code.png?0f07117f20f6c29b63acf4f2700aee67";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/code.png
// module id = 97
// module chunks = 0